import { useAnalytics } from '@/app/context/AnalyticsContext/useAnalytics';
import { useCustomer } from '@/app/context/CustomerContext/useCustomer';
import Loader from '@/components/common/loader/Loader';
import React from 'react';

export default function ManageSubscription() {
  const {
    showCustomerPortal,
    isPro,
    isLoadingCustomerPortal,
    isCreatingCheckoutSession,
    createCheckoutSession
  } = useCustomer();

  const { trackEvent, analyticsInstance } = useAnalytics();

  return (
    <div className="flex flex-col gap-4 pr-8">
      {!isLoadingCustomerPortal && !isCreatingCheckoutSession && !isPro && (
        <button
          onClick={() => {
            trackEvent(analyticsInstance, 'account_click_upgrade_returning');
            createCheckoutSession(true);
          }}
          className="btn btn-primary btn-sm"
        >
          Upgrade to Limbiks Pro
        </button>
      )}
      {!isLoadingCustomerPortal && !isCreatingCheckoutSession && (
        <button
          onClick={() => {
            trackEvent(analyticsInstance, 'account_click_manage');

            showCustomerPortal();
          }}
          className="btn btn-primary btn-sm"
        >
          Manage my subscription
        </button>
      )}
      {isLoadingCustomerPortal && (
        <div className="flex w-full flex-col items-center gap-6">
          <div>Launching Customer Portal...</div>
          <Loader />
        </div>
      )}
      {isCreatingCheckoutSession && (
        <div className="flex w-full flex-col items-center gap-6">
          <div>Launching Secure Checkout...</div>
          <Loader />
        </div>
      )}
      <div className="" style={{ maxWidth: 300 }}>
        Click here to update your payment methods, billing information, view
        past invoices and modify or{' '}
        <span className="font-bold">cancel your subscription</span>. After
        cancelling, you will still have access to Limbiks Pro until the end of
        your purchased subscription period.
      </div>
      <div className="" style={{ maxWidth: 300 }}>
        For any additional questions about your Pro Subscription please email us
        at{' '}
        <span className="font-bold">
          <a href="mailto:support@limbiks.com">support@limbiks.com</a>
        </span>
        .
      </div>
    </div>
  );
}
